<template>
    <button :class="mode">
        <slot></slot>
    </button>
</template>
<script>
export default {
    props: {
        mode: {
            type: String,
            required: true
        }
    }
}
</script>